<template>
  <v-layout align-center justify-center row fill-height wrap>
    <v-flex xs9 sm4 md3 lg3 xl2>
      <div class="image-container">
        <img src="@/assets/images/maple-logo.png" class="image"/>
      </div>
      <v-form @submit.prevent="sendNewPassword" novalidate>
        <v-text-field
          v-model="password"
          :append-icon="showPassword ? 'visibility_off' : 'visibility'"
          :type="showPassword ? 'text' : 'password'"
          :rules="[rules.required]" label="Nova senha"
          @click:append="showPassword = !showPassword"
        />
        <v-btn class="mt-2" block type="submit" :disabled="isButtonDisabled" color="primary" data-test="button-login" :loading="actionButtonLoading">
          Criar nova senha
        </v-btn>
         <div class="link mt-3">
          <a href="/login">Voltar para tela de autenticação</a>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import * as api from '@/api'
import { message } from '@/mixins'

export default {
  name: 'NewPassword',

  data: () => ({
    password: null,
    showPassword: false,
    actionButtonLoading: false,
    rules: {
      required: value => !!value || 'Obrigatório'
    }
  }),

  mixins: [message],

  computed: {
    isButtonDisabled () {
      return (
        !this.password ||
        this.actionButtonLoading
      )
    },

    invitationToken () {
      return this.$route.query.invitation_token
    }
  },

  methods: {
    sendNewPassword () {
      api.auth.newPassword(this.invitationToken, this.password).then(response => {
        this.showMessage('Senha criada com sucesso.')
        this.$router.push('/login')
      }).catch(error => {
        this.handleErrorMessage(error)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .link
    text-align center
    display block
  .image
    width 100%
    height 100%
    background-position center center
    background-repeat no-repeat
    &-container
      display block
      text-align center
</style>
